import {
  funcLoad,
} from './index';

const locationMain = () => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {



    let jsSecBg = document.getElementById("jsSecBg")
    let jsComParticleJsWrap = document.getElementById("jsComParticleJsWrap")
    // let particleWrap = jsSecBg.querySelector(".js-particle-wrap")
    // let particle = jsSecBg.querySelector(".js-particle")
    let jsSecMain = document.getElementById("jsSecMain")
    let copy = jsSecMain.querySelector(".js-copy")
    let txt = jsSecMain.querySelector(".js-txt")


    funcLoad()


    setTimeout(() => {

      // particle.classList.add('act')
      // particle.src = particle.src

      jsComParticleJsWrap.classList.add('act')

      setTimeout(() => {
        copy.classList.add('act')
      }, 1000);

      setTimeout(() => {
        txt.classList.add('act')
      }, 1500);

      setTimeout(() => {
        // particleWrap.classList.add('act')
      }, 2000);
      setTimeout(() => {
        // particle.classList.add('none')
      }, 17700);

    }, 300);


  }
}
export default locationMain;